export default class Collapsible {

  constructor() {
    this.expander();
  }

  expander() {
    $('.faq-element .question').on('click', function(event) {
      if( $(event.target).is('a') ) {
          return true;
      }

      $('.answer', $(event.target).closest('.faq-element')).toggle();
      $('.collapsed-icon', $(event.target).closest('.faq-element')).toggleClass('expanded');
    });
  }
}
